import { EmptyData, NavMenuError } from 'shared/ui';
import { SectionMenu } from 'shared/ui/section-menu';

import { SECTION } from 'entities/navigation';
import { useGetAllBonusProgramsQuery } from 'entities/bonus-program';
import { BONUS_ROUTES } from 'shared/consts/routes/bonus';

const { label, path } = SECTION['bonuses'];

export function ConnectedBonusProgramsMenu() {
  const { data, isFetching, error } = useGetAllBonusProgramsQuery();

  // if (data && data.statusCode !== 0) {
  //   return <NavMenuError text={data.statusDescription} />;
  // }

  if (error) {
    return <NavMenuError />;
  }

  if (!isFetching && !data) {
    return <EmptyData />;
  }

  const items = data || [];

  return (
    <SectionMenu
      loading={isFetching}
      items={items}
      menuKey={path}
      absolutePath={BONUS_ROUTES.BONUSES}
      label={label}
    />
  );
}
